// @flow
import React, { type Element } from 'react';
import Loader from 'angieslist-app-platform/lib/browser/Loader';
import { analytics, analyticsActions } from 'angieslist-app-platform';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';
import { get, isEmpty } from 'lodash';
import { Alert, Col, Row } from 'angieslist-react-components';
import queryString from 'query-string';
import profileActions from '../../common/profileActions';
import showcaseActions from '../../../showcase/common/showcaseActions';
import ShowcaseGrid from './ShowcaseGrid';
import showcaseIndexAnalytics from './showcaseIndexAnalytics';
import { defaultPageProps } from '../../../../app/browser/analyticsDefaultProperties';
import type { Showcase } from '../../common/profileService';
import type { ProfileReducerState } from '../../common/profileReducer';
import * as serviceProviderActions
  from '../../../../app/common/serviceProvider/serviceProviderActions';
import './showcaseIndex.scss';
import { getServiceProviderUpgradeState } from '../../../home/common/selectors/upgradeStateSelectors';
import type { UpgradeStateType } from '../../../home/common/selectors/upgradeStateSelectors';

type Props = {
  serviceProviderId: string | number,
  userId: string,
  getShowcases: typeof profileActions.getShowcases,
  archiveShowcase: typeof profileActions.archiveShowcase,
  saveShowcaseOrder: typeof showcaseActions.saveShowcaseOrder,
  serviceProviderProfile: ProfileReducerState,
  sendEnhancedAnalyticsEvent: (rule: any) => void,
  isAdvertiser: boolean,
  isNorthStar: boolean,
  showcaseAdvertiseRequest: typeof profileActions.showcaseAdvertiseRequest,
  serviceProviderUpgradeState: UpgradeStateType,
};

type State = {
  onlineUpgradeOffer: string,
};

export class ShowcaseIndexComponent extends React.Component<Props, State> {
  componentDidMount() {
    const { serviceProviderId, getShowcases } = this.props;
    const SHOWCASE_STATUSES = ['Draft', 'Published'];
    getShowcases(serviceProviderId, SHOWCASE_STATUSES).then((resp) => {
      const showcases = get(resp, 'action.payload.body.showcases');
      let pageEventName = 'SP : My Business : Showcase';
      if (showcases.length > 0) {
        if (showcases.filter(showcase => showcase.showcaseStatus === 'Published').length > 0) {
          pageEventName = pageEventName.concat(' Published');
        } else {
          pageEventName = pageEventName.concat(' Drafts');
        }
      }
      this.props.sendEnhancedAnalyticsEvent({
        type: 'page',
        name: pageEventName,
        properties: {
          ...defaultPageProps,
        },
      });
    });
  }

  props: Props;

  render(): Element<"div"> {
    const {
      serviceProviderProfile: {
        getShowcases,
        archiveShowcase: archiveShowcaseStore,
        showcaseAdvertiseRequest: {
          isLoading: advertiseRequestInProgress,
          response: advertiseRequestSuccessful,
        },
      },
      serviceProviderId,
      userId,
      archiveShowcase,
      sendEnhancedAnalyticsEvent,
      saveShowcaseOrder,
      isAdvertiser,
      isNorthStar,
      showcaseAdvertiseRequest,
      serviceProviderUpgradeState,
    } = this.props;

    const showcases: Showcase[] = get(getShowcases, 'response.showcases');
    const showcasePendingRemoval = archiveShowcaseStore.isLoading ? get(archiveShowcaseStore, 'request.showcaseId') : undefined;
    const showSaveAndCloseSuccessAlert = typeof window !== 'undefined' && queryString.parse(window.location.search).saveSuccess === 'true';

    return (
      <div>
        <div id="Edit-Project-Showcase-Component-Container" >
          <div className="project-showcase-header-container">
            <Row className="project-showcase-header">
              <Col xs={12} sm={7} className="project-showcase-title">Project Showcase</Col>
            </Row>
          </div>
          <Loader
            loading={isEmpty(getShowcases.response) || getShowcases.isLoading}
            element={
              <div className="text-center loader-showcases">
                <i className="icon icon-load icon-spin icon-3x text-primary" />
              </div>}
          >
            <div>
              <Loader
                loading={advertiseRequestInProgress}
                element={
                  <div className="text-center loader-advertise">
                    <i className="icon icon-load icon-spin icon-3x text-primary" />
                  </div>}
              >
                <If condition={advertiseRequestSuccessful}>
                  <Alert bsStyle="success">
                    Thank you for you interest in advertising with Angi. A representative will
                    contact you within 24 hours.
                  </Alert>
                </If>
              </Loader>
              <p className="subtitle-showcase">
                Feature projects you&apos;re especially proud of — and that showcase your
                business&apos;s expertise. Adding photos can increase your contacts from
                homeowners by up to 11%.
              </p>
              <If condition={archiveShowcaseStore.error}>
                <Alert bsStyle="danger">There was an error removing your project.  Please try again later.</Alert>
              </If>
              <If condition={showSaveAndCloseSuccessAlert}>
                <Alert bsStyle="success">
                  <i className="icon icon-check-bullet showcase-icon-success" />
                  <strong>
                    Your project has been saved.
                  </strong>
                </Alert>
              </If>
              <div>
                <ShowcaseGrid
                  showcases={showcases}
                  serviceProviderId={serviceProviderId}
                  archiveShowcase={archiveShowcase}
                  showcasePendingRemoval={showcasePendingRemoval}
                  sendEnhancedAnalyticsEvent={sendEnhancedAnalyticsEvent}
                  saveShowcaseOrder={saveShowcaseOrder}
                  userId={userId}
                  advertiseRequest={showcaseAdvertiseRequest}
                  advertiseRequestPending={advertiseRequestInProgress}
                  advertiseRequestSuccessful={advertiseRequestSuccessful}
                  isAdvertiser={isAdvertiser}
                  isNorthStar={isNorthStar}
                  serviceProviderUpgradeState={serviceProviderUpgradeState}
                />
              </div>
            </div>
          </Loader>
        </div>
      </div>
    );
  }
}

export default (hot(module)(compose(
  analytics({
    ruleset: showcaseIndexAnalytics,
  }),
  connect(state => ({
    serviceProviderProfile: state.serviceProviderProfile,
    serviceProvider: get(state, 'serviceProvider.serviceProvider', {}),
    config: state.config,
    serviceProviderUpgradeState: getServiceProviderUpgradeState(state),
  }), {
    ...profileActions,
    ...analyticsActions,
    ...showcaseActions,
    ...serviceProviderActions,
  }),
  pure,
)(ShowcaseIndexComponent)): any);



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/ShowcaseIndex.js